// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__zbQmd","noInteraction":"EventWrapper_noInteraction__3rip1","pointerPassthrough":"EventWrapper_pointerPassthrough__g87m4"};